export const styles = {
  container: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '0 20px',
    width: '100%',
    height: '65px',
    borderBottom: '1px solid #F3F4F9',
  },
  headingWrapper: {
    display: 'flex',
  },
  heading: {
    fontFamily: 'Inter',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '16px',
    lineHeight: '148%',
  },
  actionContainer: {
    display: 'flex',
    cursor: 'pointer',
    flexDirection: 'row',
    columnGap: '4px',
    alignItems: 'center',
  },
  action: {
    fontFamily: 'Inter',
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '14px',
    lineHeight: '146%',
    color: '#4D6EF5',
  },
  chevronIcon: {
    width: '20px',
    height: '20px',
    color: '#4D6EF5',
  },
};
